import {h, Fragment} from "preact"
import { useEffect } from "preact/hooks"
import { useAppStateSelector } from "@nosto/preact"
import { useGrid } from "./GridContext"
import Product from "./Product"

export default function Products() {
    const { products, loading } = useAppStateSelector(state => ({
        products: state.response.products,
        loading: state.loading,
    }))
    const { gridOption, showOnModel } = useGrid()

    const gridClasses = {
        "2": "grid-template-one",
        "4": "grid-template-two",
        "6": "grid-template-three",
    }[gridOption] || "grid-template-one"

    function swymCallbackFn(swat) {
        document.addEventListener("swym:collections-loaded", function() {
            swat.initializeActionButtons(".nosto-products-wrap");
        })
    }
    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);

    useEffect(() => {
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        }, 0)
    }, [products, gridOption])

    const marketingBlocks = window.plpSettings?.marketingBlocks || []
    const validMarketingBlocks = marketingBlocks.filter(
        block => block.file && block.position && gridOption !== "3"
    )

    return (
        <div className={`${gridClasses} nosto-products-wrap`} style={{ ...(loading ? { opacity: 0.8 } : {}) }}>
            {products.hits.reduce((acc, hit, index) => {
                // Add marketing blocks at their positions
                validMarketingBlocks.forEach((block, blockIndex) => {
                    const position = parseInt(block.position, 10) - 1
                    if (index === position) {
                        const isDoubleBlock = block.size === "Double block"
                        acc.push(
                            <div
                                key={`marketing-block-${blockIndex}-${position}`}
                                className={`ns-marketing-block ns-w-100 color-outline-dark ${
                                    isDoubleBlock ? "ns-grid-span-two-col double-block" : gridOption === "2" ? "ns-grid-span-two" : ""
                                }`}
                            >
                                <a 
                                    href={block.link || "#"} 
                                    className="relative ns-marketing-link ns-w-100 h-full ns-d-block"
                                >
                                    {block.file.includes('.mp4') || block.file.includes('.webm') ? (
                                        <video
                                            src={block.file}
                                            autoPlay
                                            loop
                                            muted
                                            playsInline
                                            className="ns-marketing-video ns-w-100 h-full object-cover"
                                            aria-label="Marketing video"
                                        />
                                    ) : (
                                        <img
                                            src={block.file}
                                            alt={block.title || "Marketing content"}
                                            className="ns-marketing-image ns-w-100 h-full object-cover"
                                            data-nosto-translate
                                        />
                                    )}
                                    {(block.pretitle || block.title || block.subtitle) && (
                                        <div className="ns-marketing-text">
                                            <div className="text-white">
                                                {block.pretitle && <div className="ns-pretitle">{block.pretitle}</div>}
                                                {block.title && <div className="ns-title">{block.title}</div>}
                                                {block.subtitle && <div className="ns-subtitle">{block.subtitle}</div>}
                                            </div>
                                        
                                        </div>
                                    )}
                                </a>
                            </div>
                        )
                    }
                })

                // Add product
                acc.push(
                    <Product
                        product={hit}
                        key={hit.productId || `product-${index}`}
                        gridOption={gridOption}
                        showOnModel={showOnModel}
                    />
                )
                return acc
            }, [])}
        </div>
    )
}